export const spainFlag = require('./spain-flag.svg')